"use strict";

import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { Fields, System } from "Constants/objects";
import { formatText } from "D5Utils/functions";
import Columns from "Stores/Table/core/table/Columns";
var _System$TOTAL_FUNC_KI = System.TOTAL_FUNC_KINDS,
    COUNT = _System$TOTAL_FUNC_KI.COUNT,
    AVG = _System$TOTAL_FUNC_KI.AVG,
    SUM = _System$TOTAL_FUNC_KI.SUM,
    MIN = _System$TOTAL_FUNC_KI.MIN,
    MAX = _System$TOTAL_FUNC_KI.MAX;

var D5SummaryRow =
/*#__PURE__*/
function () {
  //// Summary values should be in the same order as items
  // in the summary | totalItems array of the DataGrid configuration
  // _summaries = [250, 999, 250, 250, 250, 250,];
  function D5SummaryRow() {
    var _this = this;

    var columns = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var isShowTotals = arguments.length > 1 ? arguments[1] : undefined;

    _classCallCheck(this, D5SummaryRow);

    _defineProperty(this, "_shouldUpdate", true);

    _defineProperty(this, "_summaries", []);

    _defineProperty(this, "_columns", []);

    _defineProperty(this, "_totalItems", []);

    _defineProperty(this, "_isShowTotals", false);

    this._isShowTotals = isShowTotals;

    if (this._isShowTotals) {
      this._columns = _.sortBy(columns, Fields.Order);
      this._totalItems = this._columns.filter(function (c) {
        return c[Fields.TotalFunction];
      }).map(function (c) {
        return {
          column: c.Name,
          summaryType: c.Name + c[Fields.TotalFunction],
          customizeText: function customizeText(_ref) {
            var value = _ref.value,
                valueText = _ref.valueText;
            var type = c[Fields.TotalFunction];
            if (value == null) return _this.funcText(type) + 0;
            if (type === COUNT) return _this.funcText(type) + value;
            return _this.funcText(type) + formatText(Columns.getColumnType(c), value);
          }
        };
      });
    }
  }

  _createClass(D5SummaryRow, [{
    key: "calcSummariesValues",
    value: function calcSummariesValues() {
      if (this._shouldUpdate && this._totalItems.length) return this.load();
      return Promise.resolve(this._summaries);
    }
  }, {
    key: "funcText",
    value: function funcText(type) {
      switch (type) {
        case COUNT:
          return 'COUNT: ';

        case AVG:
          return 'AVG: ';

        case SUM:
          return 'SUM: ';

        case MIN:
          return 'MIN: ';

        case MAX:
          return 'MAX: ';

        default:
          return '';
      }
    }
  }, {
    key: "load",
    value: function load() {
      //todo use load object
      //todo https://teamtrack.macc.com.ua/view.php?id=59239
      //todo https://teamtrack.macc.com.ua/view.php?id=60291
      this._shouldUpdate = false;
      return Promise.resolve(this._summaries);
    }
  }, {
    key: "shouldUpdate",
    value: function shouldUpdate() {
      this._shouldUpdate = true;
    }
  }, {
    key: "repaint",
    value: function repaint() {
      try {// const contr = inst.getController('data');
        //
        // console.log(contr);
        // const visibleColumnIndex = 3;
        //     contr._footerItems[0].summaryCells[visibleColumnIndex][0].value = 777;
        //     contr._fireChanged({changeType: 'refresh'});
      } catch (e) {
        console.error('Summary row was not updated');
      }
    }
  }, {
    key: "totalItems",
    get: function get() {
      return this._totalItems;
    }
  }]);

  return D5SummaryRow;
}();

export { D5SummaryRow as default };